import { motion } from "framer-motion";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { overline } from "@/components/kit";
import { CITY_DATA, CITY_IMAGES } from "@/data/cities";
import { CityProjects, CityCTA } from "@/components/CityShared";
import CityLocalBusinessJsonLd from "@/components/CityLocalBusinessJsonLd";

// BORDEAUX — Centered elegant serif + alternating rows
export default function CityBordeaux() {
  const c = CITY_DATA.bordeaux;
  return (
    <>
      <Seo title={`Événementiel à ${c.name}`} description={c.seoDesc} path="/villes/bordeaux" />
      <CityLocalBusinessJsonLd city={c} />
      <section className="mx-auto max-w-4xl px-5 pt-40 pb-16 text-center md:pt-48">
        <Reveal><span className={overline}>{c.region}</span></Reveal>
        <Reveal delay={1}><h1 className="mt-6 font-serif text-6xl font-medium leading-[0.95] tracking-tight text-ink md:text-8xl">L'événementiel<br />à <span className="italic text-lime-dim">{c.name}</span></h1></Reveal>
        <Reveal delay={2}><p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-ink/65">{c.intro}</p></Reveal>
      </section>

      <Reveal>
        <div className="mx-auto max-w-5xl px-5 md:px-0">
          <motion.div initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 1 }} className="overflow-hidden rounded-2xl">
            <img src={CITY_IMAGES.event} alt={c.name} className="aspect-[21/9] w-full object-cover" />
          </motion.div>
        </div>
      </Reveal>

      <section className="mx-auto max-w-[1200px] px-5 py-20 md:px-10 md:py-28">
        {c.body.map((p, i) => (
          <Reveal key={i} delay={i}>
            <div className={`mb-12 max-w-2xl ${i % 2 === 1 ? "ml-auto text-right" : ""}`}><p className="text-2xl leading-relaxed text-ink/75">{p}</p></div>
          </Reveal>
        ))}
        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {c.highlights.map((h, i) => (
            <Reveal key={i} delay={i}>
              <div className="border-t-2 border-lime pt-6"><h3 className="font-serif text-2xl text-ink">{h.k}</h3><p className="mt-3 text-sm text-ink/55">{h.v}</p></div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={1}><p className="mt-14 text-center font-serif text-xl italic text-ink/50">{c.quartiers.join("  —  ")}</p></Reveal>
      </section>

      <CityProjects city={c.name} />
      <CityCTA city={c.name} />
    </>
  );
}
